import { render, staticRenderFns } from "./EditClient.vue?vue&type=template&id=0beb8744"
import script from "./EditClient.vue?vue&type=script&lang=js"
export * from "./EditClient.vue?vue&type=script&lang=js"
import style0 from "./EditClient.vue?vue&type=style&index=0&id=0beb8744&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports